import type { ErrorVariant } from "./error-presets";

export class WayflyerError extends Error {
  public name: string;
  public variant: ErrorVariant;
  constructor(message: string, variant: ErrorVariant) {
    super(message);
    this.name = "WayflyerError";
    this.variant = variant;
  }
}
